<template>
  <div class="ads-page">
    <navbarBox></navbarBox>
    <adsBox></adsBox>
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import adsBox from "../components/adsBox";
export default {
  name: "ads",
  components: { navbarBox, adsBox },
};
</script>

<style>
.ads-page {
  height: 100%;
}
</style>